import * as THREE from 'three';
import { type PlayerAppearance } from '../protocol';
import { buildPlayerMesh } from './remote-players';

export class CharacterPreview {
  private renderer: THREE.WebGLRenderer;
  private scene: THREE.Scene;
  private camera: THREE.PerspectiveCamera;
  private mesh: THREE.Group | null = null;
  private animId = 0;
  private rotation = 0;

  constructor(canvas: HTMLCanvasElement) {
    this.renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    this.renderer.setSize(canvas.width, canvas.height);
    this.renderer.setPixelRatio(window.devicePixelRatio);

    this.scene = new THREE.Scene();

    this.camera = new THREE.PerspectiveCamera(35, canvas.width / canvas.height, 0.1, 50);
    this.camera.position.set(0, 1.8, 4.5);
    this.camera.lookAt(0, 1.2, 0);

    const dir = new THREE.DirectionalLight(0xffffff, 1.5);
    dir.position.set(3, 5, 4);
    this.scene.add(dir);

    const ambient = new THREE.AmbientLight(0xffffff, 0.6);
    this.scene.add(ambient);

    this.animate();
  }

  updateAppearance(appearance: PlayerAppearance) {
    if (this.mesh) {
      this.scene.remove(this.mesh);
      this.mesh.traverse((child) => {
        if (child instanceof THREE.Mesh) {
          child.geometry.dispose();
          if (child.material instanceof THREE.Material) child.material.dispose();
        }
        if (child instanceof THREE.Sprite) {
          if (child.material.map) child.material.map.dispose();
          child.material.dispose();
        }
      });
    }
    this.mesh = buildPlayerMesh('', appearance);
    // Hide the name tag for preview
    this.mesh.traverse((child) => {
      if (child.name === 'nameTag') child.visible = false;
    });
    this.scene.add(this.mesh);
  }

  private animate = () => {
    this.animId = requestAnimationFrame(this.animate);
    this.rotation += 0.008;
    if (this.mesh) {
      const bodyGroup = this.mesh.getObjectByName('bodyGroup');
      if (bodyGroup) {
        bodyGroup.rotation.y = this.rotation;
      }
    }
    this.renderer.render(this.scene, this.camera);
  };

  dispose() {
    cancelAnimationFrame(this.animId);
    if (this.mesh) {
      this.scene.remove(this.mesh);
      this.mesh.traverse((child) => {
        if (child instanceof THREE.Mesh) {
          child.geometry.dispose();
          if (child.material instanceof THREE.Material) child.material.dispose();
        }
      });
    }
    this.renderer.dispose();
  }
}
